import { render, staticRenderFns } from "./RightNav.vue?vue&type=template&id=165713d4&scoped=true"
import script from "./RightNav.vue?vue&type=script&lang=js"
export * from "./RightNav.vue?vue&type=script&lang=js"
import style0 from "./RightNav.vue?vue&type=style&index=0&id=165713d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165713d4",
  null
  
)

export default component.exports